module.exports = __webpack_public_path__ + "assets/0e58d43c1d891dd758c69d33ef3b4048.png";